import { render, staticRenderFns } from "./VerificationAccountView.vue?vue&type=template&id=b240e62e&scoped=true"
import script from "./VerificationAccountView.vue?vue&type=script&lang=js"
export * from "./VerificationAccountView.vue?vue&type=script&lang=js"
import style0 from "./VerificationAccountView.vue?vue&type=style&index=0&id=b240e62e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b240e62e",
  null
  
)

export default component.exports